import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { MainHeader } from '.';
import { useTree } from '../../../Context/useTree';

let ItemList = () => {
    const navigation = useNavigate();
    const { location, menuId, submenuId } = useParams();
    const { treeData, fetchTree, findMenuById, findSubmenuById } = useTree();
    const [items, setItems] = useState([]);

    useEffect(() => {
        // Use submenuId if provided, otherwise use menuId
        const idToSearch = submenuId || menuId;
        console.log(idToSearch)
        
        fetchTree(location)
            .then((tree) => {
                const menus = tree?.menus || [];

                const findSubmenuByIdRecursive = (submenus, id) => {
                    if (!submenus) return null;
                    for (const submenu of submenus) {
                        if (submenu.submenuId === id) {
                            return submenu;
                        }
                        const nested = findSubmenuByIdRecursive(submenu.children, id);
                        if (nested) return nested;
                    }
                    return null;
                };

                const getItemsFromTree = () => {
                    const menuIdNumber = Number(menuId);
                    const submenuIdNumber = submenuId ? Number(submenuId) : null;

                    for (const menu of menus) {
                        if (submenuIdNumber !== null) {
                            const submenu = findSubmenuByIdRecursive(menu.submenus, submenuIdNumber);
                            if (submenu && submenu.items) {
                                return submenu.items;
                            }
                        } else {
                            if (menu.menuId === menuIdNumber && menu.items) {
                                return menu.items;
                            }
                            const submenu = findSubmenuByIdRecursive(menu.submenus, menuIdNumber);
                            if (submenu && submenu.items) {
                                return submenu.items;
                            }
                        }
                    }
                    return null;
                };

                const foundItems = getItemsFromTree();
                if (foundItems) {
                    setItems(foundItems);
                } else {
                    console.warn('ItemList: no items found for', { location, menuId, submenuId, menus });
                }
            })
            .catch((error) => {
                console.error("Error fetching tree:", error);
            });

    }, [location, menuId, submenuId]);

    const catigoryItems = items.map(item => {
        // Use menuItemId from tree items, fallback to MenuItemID from old API
        const itemId = item.menuItemId || item.MenuItemID;
        const itemName = item.itemName || item.displayName || "Item";
        
        // Use tree colors (htmlColor1, htmlColor2, htmlColor3) or fallback to defaults.
        // Apply backend-provided button styles when present.
        const backendButtonStyles = item.buttonStyles || item.buttonStyle || item.style || {};
        const defaultBackground = `linear-gradient(135deg, '#FFFFFF' 0%,  '#CCCCCC' 45%,  '#999999' 100%)`;
        const buttonBackground = backendButtonStyles.background ?? backendButtonStyles.backgroundColor ?? defaultBackground;
        const buttonBorder = backendButtonStyles.border ?? ((backendButtonStyles.borderColor || backendButtonStyles.borderWidth || backendButtonStyles.borderStyle)
            ? `${backendButtonStyles.borderWidth || '2px'} ${backendButtonStyles.borderStyle || 'solid'} ${backendButtonStyles.borderColor || '#000000'}`
            : '2px solid color-mix(in srgb, #FFFFFF 70%, #ffffff 30%)');
        const buttonStyles = {
            ...backendButtonStyles,
            background: buttonBackground,
            color: backendButtonStyles.color ?? backendButtonStyles.color ?? '#000000',
            border: buttonBorder,
            borderRadius: backendButtonStyles.borderRadius ?? '16px',
            padding: backendButtonStyles.padding ?? '16px 20px',
            fontFamily: backendButtonStyles.fontFamily ?? 'inherit',
            fontSize: backendButtonStyles.fontSize ?? 'inherit',
            fontWeight: backendButtonStyles.fontWeight ?? 600,
            boxSizing: 'border-box'
        };
        
        return (
            <button
                key={itemId}
                className="item-list-single-item"
                style={buttonStyles}
                onClick={() => navigation(`/v2/${location}/${menuId}/items/${itemId}`)}>
                {itemName}
            </button>
        )
    })

    return (
        <>
            <div>
                <MainHeader />
                <div className="body">
                    {/* <h5>Items </h5> */}
                    <div className="item-list-wrapper">
                        {catigoryItems}
                    </div>
                </div>
            </div>


        </>
    );
}

export default ItemList;